/* eslint-disable react/jsx-props-no-spreading */
const StepOneIcon = (props) => (
	<svg width={128} height={120} viewBox="0 0 128 120" {...props}>
		<g fill="none" fillRule="evenodd">
			<circle cx="60" cy="60" r="60" fill="#FFF" opacity=".327" />
			<rect
				width="45"
				height="53"
				x="37.5"
				y="33.5"
				fill="#FFF"
				stroke="#4D3951"
				strokeWidth="3"
				rx="2"
			/>
			<path
				fill="#ED767E"
				stroke="#4D3951"
				strokeWidth="3"
				d="M45.5 41.5H74.5V48.5H45.5z"
			/>
			<path
				fill="#FFF"
				stroke="#4D3951"
				strokeWidth="3"
				d="M45.5 41.5H54.5V48.5H45.5z"
			/>
			<path
				fill="#4D3951"
				d="M50 58H56V60H50zM44 57H48V61H44zM69 58H75V60H69zM63 57H67V61H63zM50 66H56V68H50zM44 65H48V69H44zM69 66H75V68H69zM63 65H67V69H63zM50 74H56V76H50zM44 73H48V77H44zM69 74H75V76H69zM63 73H67V77H63z"
			/>
			<g transform="translate(88)">
				<circle cx="20" cy="20" r="20" fill="#FFF" />
				<text
					fill="#373737"
					fontFamily="Inter"
					fontSize="24"
					fontWeight="700"
				>
					<tspan x="14.216" y="28">
						1
					</tspan>
				</text>
			</g>
		</g>
	</svg>
);

export default StepOneIcon;
